<template>
  <div class="order-tip-content">
    <!--  竞价须知-->
    <template v-if="type === 'prerequisites'">
      <p>
        （1）竞价方成功报名并在报名时间结束后，请在竞价开始前1小时内点击页面下方“竞价大厅”中的[进入竞价大厅]按钮即可进入竞价大厅等待竞价开始。
      </p>
      <P>（2）本次竞拍不限报价次数，每次提交报价后即可查看当前报价排名。</P>
      <p>
        （3）若由于竞价方遗失密码、操作失误或因竞价方计算机设备、网络故障等原因，造成无法竞价或竞价失误，由竞价方自行承担相应后果。
      </p>
    </template>

    <!--  注意事项-->
    <template v-if="type === 'caveat'">
      <p>
        （1）登录“精彩纵横云采购平台”（https://www.yingcaicheng.com）公告查看页面点击“查看详情”。请未注册的竞价方及时办理平台注册审核流程，注册咨询电话：{{
          consumerHotline
        }}。因未及时办理注册审核手续影响报名及竞价的，责任自负。
      </p>
      <p>
        （2）报名单位需填写报名信息，如报名需要审核，请按公告要求上传相应报名资料，报名及报价过程中如有任何平台操作问题，请联系平台客服。
      </p>
      <p>
        （3）请在报名成功后，及时缴纳保证金。若因未及时缴纳保证金的竞价方造成无法参与此次竞价，由竞价方自行承担相应后果。已缴纳保证金的竞价方将在竞价结束后5日内有息退回至原缴纳保证金账户。
      </p>
      <p>（4）参加本次竞价的竞价方需熟悉竞价规则及竞价方法。</p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CompeteCopywriter',

  props: {
    // 竞价须知：prerequisites  注意事项：caveat
    type: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapState('system', ['consumerHotline'])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.order-tip-content {
  font-size: pixel-to-rem($n: 20);

  p {
    margin: 0;
    line-height: 1.5;
  }
}
</style>
